export const environment = {
  production: true,
  debug: false,
  useRecaptcha: true,
  showThemeSwitcher: true, // Always show in demo
  clientId: '',
  orgId: '',
  apiKey: 'AIzaSyDp2hdGdFPQmUXJC1eXSaVEul3cw8murl4',
  confUrl: 'https://tl-infra.apis.tensorlinks.xyz',
  apiUrl: 'https://apis.tensorlinks.xyz/patient-portal',
  tenantId: 'brightsmiledental',
  googleMapsApiKey: '', // TODO: Create restricted Maps API key when patient portal goes live
  firebase: {
    apiKey: "AIzaSyDp2hdGdFPQmUXJC1eXSaVEul3cw8murl4",
    authDomain: "project-001-demo-463023.firebaseapp.com",
    projectId: "project-001-demo-463023",
    storageBucket: "project-001-demo-463023.firebasestorage.app",
    messagingSenderId: "240758130642",
    appId: "1:240758130642:web:4e4a378c46df0b74e2aa0b"
  },
  // reCAPTCHA is handled automatically by Firebase for phone auth
  // No separate site key needed when using RecaptchaVerifier from @angular/fire/auth
  recaptcha: {
    siteKey: '6Ldb7NgrAAAAAAm6BGdzvuSsLrteLgp4WPZqIfYA',  // Not needed for Firebase phone auth
  },
  release: {
    version: '1.2.2',
    date: '2025-06-30',
    notes: 'Demo environment release',
  }
};